module.exports = "/_next/static/images/Cabling-11b206c3aa8bd49d7a7a419b03c0d7db.jpg";